import { AddCameraGroupDTO, CameraGroupPayload } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useAddCameraGroup(
  onSuccess?: (data: AddCameraGroupDTO) => void
) {
  const url = `/v2/orm/camera_groups`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<AddCameraGroupDTO, CameraGroupPayload>(
    request,
    {
      onSuccessInvalidationKeys: [['camera-groups']],
      onSuccess,
    }
  );
}

export default useAddCameraGroup;
